{
	"year": "{0}년",
	"quarter": "{0}분기",
	"month": "{0}개월",
	"week": "{0}주",
	"day": "{0}일",
	"hour": "{0}시간",
	"minute": "{0}분",
	"second": "{0}초",
	"now": "지금"
}